import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { UnstyledButton } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/pro-regular-svg-icons";
import { Button } from "@/components/button";
import { useDeleteReminder } from "@/hooks/tasks";
import { useSelectedPatientStore } from "@/stores/selected-patient";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { TaskDeleteConfirm } from "./task-delete-confirm";
/** Footer actions of the task detail panel: delete (with confirmation) and mark as done. */
export function TaskDetailFooter(_ref) {
  var reminder = _ref.reminder,
    onClose = _ref.onClose,
    onMarkDone = _ref.onMarkDone,
    _ref$isMarkingDone = _ref.isMarkingDone,
    isMarkingDone = _ref$isMarkingDone === void 0 ? false : _ref$isMarkingDone;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    isDeleteConfirmOpen = _useState[0],
    setIsDeleteConfirmOpen = _useState[1];
  var patientUid = useSelectedPatientStore(function (s) {
    var _s$selectedPatient;
    return (_s$selectedPatient = s.selectedPatient) !== null && _s$selectedPatient !== void 0 && _s$selectedPatient.patient_uid ? String(s.selectedPatient.patient_uid) : null;
  });
  var _useDeleteReminder = useDeleteReminder(patientUid),
    deleteReminder = _useDeleteReminder.mutate,
    isDeletingTask = _useDeleteReminder.isLoading;
  var handleDelete = function handleDelete() {
    deleteReminder(reminder.id, {
      onSuccess: function onSuccess() {
        setIsDeleteConfirmOpen(false);
        onClose();
      }
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between px-5 py-4 border-t border-sds-base-default flex-shrink-0"
  }, /*#__PURE__*/React.createElement(UnstyledButton, {
    "data-testid": "task-detail-delete",
    "aria-label": t("button.delete"),
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.TASK_DETAIL_DELETE, {
        taskId: reminder.id
      });
      setIsDeleteConfirmOpen(true);
    },
    disabled: isDeletingTask,
    className: "w-8 h-8 flex items-center justify-center rounded-sds-100 text-sds-base-secondary hover:bg-sds-urgent-tertiary hover:text-sds-urgent-default transition-colors disabled:opacity-50 disabled:pointer-events-none"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faTrash,
    className: "w-3.5 h-3.5"
  })), /*#__PURE__*/React.createElement(Button, {
    "data-testid": "task-detail-mark-done",
    intent: "brand",
    variant: "primary",
    onClick: function onClick() {
      trackEvent(ANALYTICS_EVENTS.TASK_DETAIL_MARK_DONE, {
        taskId: reminder.id
      });
      onMarkDone === null || onMarkDone === void 0 || onMarkDone();
    },
    disabled: reminder.resolved,
    loading: isMarkingDone
  }, isMarkingDone ? t("loading") : t("label.mark_as_done"))), /*#__PURE__*/React.createElement(TaskDeleteConfirm, {
    opened: isDeleteConfirmOpen,
    isDeleting: isDeletingTask,
    onClose: function onClose() {
      return setIsDeleteConfirmOpen(false);
    },
    onConfirm: handleDelete
  }));
}